import { createFileRoute } from "@tanstack/react-router";
import {
    ContactHandoffRoute,
    providerOutreachHandoffRoute,
} from "@/features/provider-outreach";

export const Route = createFileRoute("/c/$token")({
    validateSearch: providerOutreachHandoffRoute.validateSearch,
    loaderDeps: providerOutreachHandoffRoute.loaderDeps,
    loader: providerOutreachHandoffRoute.loader,
    preload: false,
    head: providerOutreachHandoffRoute.head,
    headers: providerOutreachHandoffRoute.headers,
    component: ContactHandoffRoute,
});
